import { EProductVariantConnectionSettings } from '@gelato-api-ui/sdk/src/lib/shared/e-product-variant-connection-settings-modal/types/e-product-variant-connection-settings';

export const DefaultEProductVariantConnectionSettings: EProductVariantConnectionSettings = {
  updatePrice: true,
  updatePreview: true,
  currency: null,
  price: null,
  cost: null,
};
